module.exports = __webpack_public_path__ + "img/flavor_pineapple_green.6389b405.png";